import React, { useEffect, useState } from "react";
import Header from "./header";
import Footer from "./footer";
import AdPopup from "./ad-popup";
import { useIsEditionSpotlightMagazine } from "../hooks/use-is-edition-spotlight-magazine";
import Search from "./search";
import SetSubscriptionInfo from "./set-subscription-info";
import { globalHistory } from "@reach/router";
const Layout = _ref => {
    let { children, className } = _ref;
    const { 0: searchVisible, 1: setSearchVisible } = useState(false);
    const onToggleSearch = () => {
        setSearchVisible(!searchVisible);
    };
    useEffect(() => {
        const historyListener = globalHistory.listen(_ref2 => {
            let { action, location } = _ref2;
            if (["POP", "PUSH"].includes(action)) {
                if (location.search.includes("search=")) {
                    setSearchVisible(true);
                }
            }
        });
        if (window.location.search.includes("search=")) {
            setSearchVisible(true);
        }
        return () => historyListener();
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        className: `container mx-auto shadow flex flex-nowrap w-full ${className} ${useIsEditionSpotlightMagazine()}`
    }, /*#__PURE__*/ React.createElement("div", {
        className: "min-h-screen bg-white",
        style: {
            flex: "0 0 12px"
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: "bg-makroGreyLight min-h-screen flex-1 w-full"
    }, /*#__PURE__*/ React.createElement(SetSubscriptionInfo, null), /*#__PURE__*/ React.createElement(AdPopup, null), /*#__PURE__*/ React.createElement(Header, {
        onOpenSearch: onToggleSearch,
        setVisibility: setSearchVisible
    }), /*#__PURE__*/ React.createElement(Search, {
        visible: searchVisible,
        setVisibility: setSearchVisible
    }), /*#__PURE__*/ React.createElement("main", {
        className: `bg-white w-full ${searchVisible ? "hidden" : "block"}`
    }, children), /*#__PURE__*/ React.createElement(Footer, null)), /*#__PURE__*/ React.createElement("div", {
        className: "min-h-screen bg-white",
        style: {
            flex: "0 0 12px"
        }
    }));
};
export default Layout;
